import { render, staticRenderFns } from "./DepreciationMenubar.vue?vue&type=template&id=f97d51d0&scoped=true&"
import script from "./DepreciationMenubar.vue?vue&type=script&lang=js&"
export * from "./DepreciationMenubar.vue?vue&type=script&lang=js&"
import style0 from "./DepreciationMenubar.vue?vue&type=style&index=0&id=f97d51d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97d51d0",
  null
  
)

export default component.exports